export default __webpack_public_path__ + "static/media/img-b-result-distance-kr_kr@2x.bb08f36d.jpg";